import React from 'react';
import './Badge.css';

const Badge = ({ 
  children, 
  variant = 'default',
  size = 'medium',
  icon,
  className = '',
  ...props 
}) => {
  const badgeClass = `ui-badge ui-badge--${variant} ui-badge--${size} ${className}`;
  
  return (
    <span className={badgeClass} {...props}>
      {icon && <span className="ui-badge__icon">{icon}</span>}
      <span className="ui-badge__text">{children}</span>
    </span>
  );
};

export default Badge;
